<template>
    <v-dialog
        :key="value.type + '_' + value.id"
        v-model="touched"
        max-width="480"
        persistent
        scrollable
    >
        <template #activator="{ on, attrs }">
            <slot v-bind="{ on, attrs }"></slot>
        </template>

        <v-card>
            <v-card-title class="customized-primary white--text">{{ t('app_content_title_update_tags') }}</v-card-title>

            <v-card-text class="pb-0">
                <v-form class="mt-6">
                    <v-text-field
                        v-model="value.name"
                        type="text"
                        :label="t('app_content_label_name')"
                        required
                        outlined
                        dense
                        disabled
                        :error-messages="form.errors.get('name')"
                    ></v-text-field>
                    <v-autocomplete
                        v-model="value.tags"
                        :items="tags.data"
                        item-text="slug"
                        item-value="slug"
                        filled
                        chips
                        :label="t('app_content_label_tags')"
                        multiple
                        dense
                        outlined
                        deletable-chips
                        append-icon="mdi-chevron-down"
                        :error-messages="form.errors.get('tags')"
                    ></v-autocomplete>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    color="orange"
                    @click="cancel"
                    width="45%"
                    dark
                >{{ t('general_action_back') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="submit"
                    width="45%"
                    dark
                >{{ t('general_action_update') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, reactive, toRefs, watch} from '@vue/composition-api'
    import { useI18n } from 'vue-i18n-composable'
    import { useStore } from '@/store'
    import { useForm } from '@/core/form'
    import { useLocales } from '@/core/defaults'
    import { AppContent } from '@/core/models/app-content'
    import { TagCollection } from '@/store/modules/tag-collection'

    export default defineComponent({
        name: 'AddTagsModal.vue',

        /**
         * Component props.
         */
        props: {
            value: {
                type: AppContent,
                required: true
            }
        },

        /**
         * @param props
         * @param context
         */
        setup(props, context) {

            const store = useStore()

            const state = reactive({
                overlay: true,
                touched: false,
            })

            const i18n = useI18n()
            const form = reactive(useForm())
            const tags = computed(() => <TagCollection>store.getters['tagCollection/get'])

            const capture = () => {
                state.overlay = true
                store.dispatch('tagCollection/get', { published: 1, sort: 'slug' }).then((data) => {
                    state.overlay = false
                })
            }

            const submit = () => {
                form.usingSubmit(store.dispatch('appContent/patch',
                        { payload: props.value.payload() }
                    )).then(() => {
                        state.touched = false
                        store.dispatch('notify', { color: 'success', message: i18n.t('general_notice_data_updated') })
                    })
            }

            const cancel = () => {
                form.errors.clear()
                state.touched = false
                context.emit('cancel')
            }

            onMounted(() => {
                tags.value.data = []
                capture()
            })

            return {
                tags,
                form,
                submit,
                cancel,
                ...useI18n(),
                ...useLocales(),
                ...toRefs(state)
            }
        }
    })
</script>
